<template>
  <shipblu-prompt
    class="shipment-modal stock-request"
    @close="closeModal"
    @cancel="closeModal"
    :active.sync="outboundProductModal"
    :title="$t('Outbound Product')"
    :buttons-hidden="true" autocomplete="nofill">
    <div class="items-end grid sm:grid-cols-3 grid-cols-1 gap-4 mt-4">
      <div class="sm:col-span-2 col-span-1">
        <v-select disabled class="input-customer-info-filled remove-search w-full input-customer-info product-dropdown" 
          autocomplete="nofill" label="sku" :name="'Sku code'" v-model="outboundProductObj.product.sku" v-validate="'required'" 
          :placeholder="$t('Sku code') + '*'" :options="productCatalog"/>
        <span class="text-danger text-sm" v-show="errors.has('Sku code')">{{ errors.first('Sku code') }}</span>
      </div>
      <div class="col-span-1 flex items-center w-full justify-between">
        <div class="md:block flex items-center">
          <p class="text-sm text-lightgray mr-1">{{ $t('Recall Quantity') }}:</p>
          <div>
            <vs-input-number min="0" :max="maxOutboundedQuantity" v-validate="'required|numeric'" name="quantity" v-model="outboundProductObj.recall_quantity" class="stock-request-input-number flex justify-start"/>
            <span class="text-danger text-sm" v-show="errors.has('quantity')">{{ errors.first('quantity') }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-10">
      <p class="font-medium text-lg">{{$t('Storage Units')}}</p>
      <div v-if="SkuStorageUnits?.length" class="grid sm:grid-cols-3 grid-cols-1 gap-2 mt-4">
        <div v-for="item in SkuStorageUnits" :key="item.id" class="bg-[#f7f9fcb8] border border-solid border-[#9dadc252] rounded-md flex items-center justify-between px-4 py-3">
          <div>
            <p class="text-xs text-lightgray">{{ $t('Storage Unit') }}</p>
            <p class="text-sm font-medium text-primary mt-1">{{ item.storage_unit }}</p>
          </div>
          <div class="text-right">
            <p class="text-xs text-lightgray">{{ $t('Stored Quantity') }}</p>
            <p class="text-sm font-medium mt-1">{{ item.stored_quantity }}</p>
          </div>
        </div>
      </div>
      <div v-else class="bg-[#f7f9fcb8] border border-solid border-[#9dadc252] rounded-md flex items-center justify-center mt-4 px-4 py-5">
        <p class="text-sm text-lightgray">{{ $t('No Storage Units') }}</p>
      </div>

      <div v-if="SkuStorageUnits?.length">
        <div v-for="(item, index) in storageUnits" :key="index">
          <div class="items-end grid sm:grid-cols-3 grid-cols-1 gap-4 mt-4 mb-6">
            <div class="sm:col-span-2 col-span-1">
              <v-select search :class="item.storage ? 'input-customer-info-filled remove-search' : ''" class="w-full input-customer-info product-dropdown" 
                autocomplete="nofill" label="storage_unit" :name="'Storage Unit'" v-model="item.storage" v-validate="'required'" 
                :placeholder="$t('Storage Unit') + '*'" :options="SkuStorageUnits"/>
              <span class="text-danger text-sm" v-show="errors.has('Storage Unit')">{{ errors.first('Storage Unit') }}</span>
            </div>
            <div class="col-span-1 flex items-center w-full justify-between">
              <div class="md:block flex items-center">
                <p class="text-xs text-lightgray mr-1">{{ $t('Outbound Quantity') }}:</p>
                <div>
                  <vs-input-number min="0" v-validate="'required|numeric'" :class="(outboundProductObj.recall_quantity- totalOutboundedQuantity === 0) ? 'input-number-disabled' : ''" name="quantity" v-model="item.outbound_quantity" :max="outboundProductObj.recall_quantity" class="stock-request-input-number flex justify-start"/>
                  <span class="text-danger text-sm" v-show="errors.has('quantity')">{{ errors.first('quantity') }}</span>
                </div>
              </div>
              <span v-if="storageUnits.length > 1" @click="removeStorageUnits(index)" class="remove-package-icon cursor-pointer">
                <feather-icon icon="XIcon" svgClasses="w-4 h-3"/>
              </span>
            </div>
          </div>
        </div>

        <div v-if="addMoreStorage" class="relative flex items-center justify-end mt-8">
          <div class="absolute add-products">
            <span class="text-sm font-medium py-1 px-2 rounded tooltip bg-white text-primary">{{$t('Add more Storage Units')}}</span>
          </div>
          <div class="p-1 flex self-center bg-primary rounded">
            <feather-icon @click="addStorage()" class="cursor-pointer" icon="PlusIcon" svgClasses="w-5 h-5 text-white" />
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-2 gap-4 mt-10">
      <button @click="closeModal" class="btn disable-btn">{{ $t('Cancel') }}</button>
      <button :disabled="!SkuStorageUnits?.length" @click="outboundProduct" :class="`btn ${SkuStorageUnits?.length ? 'active-btn' : 'disable-btn cursor-not-allowed'}`">{{ $t('Save') }}</button>
    </div>
  </shipblu-prompt>
</template>

<script>
import ShipbluPrompt from '../../../layouts/components/ShipBluPrompt.vue'
import {sendFulfillmentRequest} from '../../../http/axios/requestHelper.js'
import i18nData from '../../../i18n/i18nData.js'
import vSelect from 'vue-select'

export default {
  props: ['outboundProductModal', 'SkuStorageUnits', 'outboundProductObj'],
  data () {
    return {
      productCatalog: [],
      storageUnits: [
        {
          bin: '',
          outbound_quantity: 0
        }
      ],
      totalOutboundedQuantity: 0,
      addMoreStorage: true,
      storageUnitsOptions: [],
      searchVal: '',
      maxOutboundedQuantity: 0
    }
  },
  watch: {
    'outboundProductObj.recall_quantity' (val) {
      this.storageUnits = []
      this.storageUnits.push(
        {
          bin: '',
          outbound_quantity: this.outboundProductObj.recall_quantity
        }
      )
      this.storageUnits[0].outbound_quantity = val
    },
    'outboundProductModal' (val) {
      if (val === true) {
        this.storageUnits = []
        this.maxOutboundedQuantity = this.outboundProductObj.recall_quantity
        this.storageUnits.push(
          {
            bin: '',
            outbound_quantity: this.outboundProductObj.recall_quantity
          }
        )
        this.storageUnits[0].outbound_quantity = this.outboundProductObj.recall_quantity
      }
    },
    'storageUnits': {
      handler (val) {
        this.totalOutboundedQuantity = 0
        val.forEach(item => {
          this.totalOutboundedQuantity += Number(item.outbound_quantity)
        })
        if (this.totalOutboundedQuantity >= this.outboundProductObj.recall_quantity) {
          this.addMoreStorage = false
        } else {
          this.addMoreStorage = true
        }
      },
      deep: true
    }
  },
  components: {
    ShipbluPrompt,
    vSelect
  },
  methods: {
    removeStorageUnits (index) {
      this.storageUnits.splice(index, 1)
    },
    addStorage () {
      this.storageUnits.push({
        bin: '',
        outbound_quantity: this.outboundProductObj.recall_quantity - this.totalOutboundedQuantity
      })
    },
    closeModal () {
      this.$emit('outboundProductModal', false)
      this.$emit('loadStockProducts')
    },
    outboundProduct () {
      if (!this.SkuStorageUnits?.length) {
        return
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          const binsInStorage = []
          this.storageUnits.forEach(item => {
            binsInStorage.push({
              storage_unit: item.storage.id,
              recall_quantity: Number(item.outbound_quantity)
            })
          })
          sendFulfillmentRequest(false, false, this, `api/v1/fc/stock-recalls/${this.$route.params.stockID}/products/${this.outboundProductObj?.product?.id}/`, 'patch', {storage_unit_recalls: binsInStorage}, true,
            () => {
              this.$vs.notify({
                color:'success',
                title:i18nData[this.$i18n.locale]['Success'],
                text:i18nData[this.$i18n.locale]['Product'] + i18nData[this.$i18n.locale][' has been updated successfully!'],
                position: 'top-center'
              })
              this.closeModal()
            }
          )
        }
      })
    }
  }
}
</script>

<style lang="scss">
.add-products {
  right: 33px;
  .tooltip {
    box-shadow: 0px 0px 6px rgba(108, 132, 163, 0.6);
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      margin-top: -7px;
      border-width: 7px;
      border-style: solid;
      border-color: transparent #1C5BFE transparent transparent;
    }
  }
}
.remove-package-icon {
  background: rgba(157, 173, 194, 0.32);
  border-radius: 3px;
  padding: 0px 4px;
  &:hover {
    background: #9DADC2;
    color: #fff;
  }
}
div.stock-request {
  .vs-input-number {
    * {
      padding: 0px !important;
    }
  }
  .vs-input-number--input {
    font-size: 15px !important;
  }
  .vs-input-number {
    margin: 0px 10px!important;
  }
  .vs-dialog{
    max-width: 800px !important;
  }
}
div.stock-request-input-number {
  button {
    width: 15px !important;
    height: 15px !important;
    
  }
}
.input-number-disabled {
  button.btn-plus {
    pointer-events: none;
    background: rgba(0,0,0,.5);
    opacity: 0.5;
  }
}
</style>